import { createContext } from 'react';
export var SaveContext = createContext({});
//# sourceMappingURL=SaveContext.js.map